module.exports = __webpack_public_path__ + "b404025c1490468a3fe974a7d9c8e92f.jpeg";


//////////////////
// WEBPACK FOOTER
// ./avatar.jpeg
// module id = 494
// module chunks = 0